<template>
  <svg :viewBox="viewBox" :height="height" :width="svgWidth">
    <circle
      v-for="(option, index) in options"
      :key="option.value"
      :cx="CIRCLE_RADIUS + STROKE_WIDTH + fullCircleDiameter * index + GAP * index"
      :cy="CIRCLE_RADIUS + STROKE_WIDTH"
      :r="CIRCLE_RADIUS"
      :stroke-width="STROKE_WIDTH"
      class="cursor-pointer hover:opacity-80"
      :class="[
        option.strokeClass,
        modelValue.includes(option.value) ? option.selectedFillClass : 'fill-transparent',
      ]"
      @click="toggleOption(option)"
    />
    <g v-if="isAnyValueSelected" id="x-mark">
      <line
        :x1="viewBoxWidth - fullCircleDiameter + STROKE_WIDTH"
        :y1="STROKE_WIDTH"
        :x2="viewBoxWidth - STROKE_WIDTH"
        :y2="fullCircleDiameter - STROKE_WIDTH"
        :stroke-width="STROKE_WIDTH"
        class="stroke-gray-30"
      />
      <line
        :x1="viewBoxWidth - fullCircleDiameter + STROKE_WIDTH"
        :y1="fullCircleDiameter - STROKE_WIDTH"
        :x2="viewBoxWidth - STROKE_WIDTH"
        :y2="STROKE_WIDTH"
        :stroke-width="STROKE_WIDTH"
        class="stroke-gray-30"
      />

      <!--xmark clickable area-->
      <rect
        id="clickable-xmark"
        @click="removeFilter"
        :x="viewBoxWidth - fullCircleDiameter"
        :y="0"
        :width="fullCircleDiameter"
        :height="fullCircleDiameter"
        class="fill-transparent cursor-pointer"
      />
    </g>
  </svg>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'

export interface StatusOption {
  value: string
  strokeClass: string
  selectedFillClass: string
}

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (event: 'update:modelValue', value: string[]): void
}>()

const props = withDefaults(
  defineProps<{
    options: StatusOption[]
    modelValue: string[]
    height?: string | number
  }>(),
  {
    height: 14,
  },
)
const { options, modelValue, height } = toRefs(props)

const STROKE_WIDTH = 2
const CIRCLE_RADIUS = 5
const GAP = 16
const viewBoxWidth = computed(function () {
  const circlesGroupWidth =
    (CIRCLE_RADIUS + STROKE_WIDTH) * 2 * options.value.length + (options.value.length - 1) * GAP
  const xMarkerSpace = isAnyValueSelected.value ? fullCircleDiameter + GAP : 0
  return circlesGroupWidth + xMarkerSpace
})
const fullCircleDiameter = (CIRCLE_RADIUS + STROKE_WIDTH) * 2
const viewBox = computed<string>(function () {
  return `0 0 ${viewBoxWidth.value} ${fullCircleDiameter}`
})
const svgWidth = computed<number>(function () {
  return Math.round((+height.value * viewBoxWidth.value) / fullCircleDiameter)
})

const isAnyValueSelected = computed<boolean>(function () {
  return options.value.some(option => modelValue.value.includes(option.value))
})

function toggleOption(option: StatusOption) {
  if (modelValue.value.includes(option.value)) {
    emit(
      'update:modelValue',
      modelValue.value.filter(value => value !== option.value),
    )
  } else {
    emit('update:modelValue', [...modelValue.value, option.value])
  }
}
function removeFilter() {
  emit('update:modelValue', [])
}
</script>
